import React from 'react';
import { InputLabel, FormControl, Select, MenuItem } from '@material-ui/core';

interface DropdownSelectProps {
  items: KeyValuePair[];
  value: string;
  label: string;
  onChange: (value: string) => void;
  cssClass?: string;
  fullWidth?: boolean;
}

const DropdownSelect = ({ items, value, label, onChange, cssClass, fullWidth }: DropdownSelectProps) => {
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;

    //callback
    onChange && onChange(value);
  };

  return (
    <FormControl className={cssClass} fullWidth={fullWidth} size="small">
      <InputLabel id="dropdownSelectLabel">{label}</InputLabel>
      <Select labelId="dropdownSelectLabel" id="dropdownSelect" value={value} onChange={handleChange}>
        {items.map((item, key) => (
          <MenuItem key={key} value={item.value}>
            {item.key}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DropdownSelect;

export interface KeyValuePair {
  key: string;
  value: string;
}
